import { render } from "./productLength.vue?vue&type=template&id=1979a6dc"
import script from "./productLength.vue?vue&type=script&lang=js"
export * from "./productLength.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__